import 'lazysizes';

import { newsSubscription } from './news_subscription';
import initIntlTelInput from './libs/initIntlTelInput';
import initModal from './libs/initMicromodal';
import initAOS from './libs/initAOS';
import scrollTo from './scrollTo';

import playVideo from './playVideo';
import playYoutubeVideo from './playYoutubeVideo';
import sendContactForm from './sendContactForm';
import enableScroll from './enableScroll';
import disableScroll from './disableScroll';

// import elements from './elements';
// import state from './state';

export const LOADER = `<div class="u_loader_wrap"><div class="u_loader"></div></div>`;
export const SLIDERS_PATH = '/img/sliders';

const app = () => {
  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = 1000;
  window.lazySizesConfig.expFactor = 4;

  const windowWidth = document.body.clientWidth;
  // const isMobile = windowWidth <= 768;
  const lessThanTabletMedium = windowWidth <= 1000;
  const greaterThanTabletMedium = windowWidth > 1000;
  // const isWideTablet = windowWidth <= 1024;
  // const isDesktop = windowWidth >= 1440;

  // const mobileMax = (width) => window.matchMedia(`(max-width: ${width}px)`).matches;
  // const desktopMin = (width) => window.matchMedia(`(min-width: ${width}px)`).matches;

  const header = document.querySelector('[data-header]');
  const burger = document.querySelector('[data-burger]');
  const desktopMenu = document.querySelector('[data-desktop-menu]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  const menuTitles = document.querySelectorAll('[data-menu-title]');
  const menuContents = document.querySelectorAll('[data-menu-content]');

  const submenuTitles = document.querySelectorAll('[data-menu-subtitle]');
  const submenuContents = document.querySelectorAll('[data-menu-subcontent]');

  const setHeaderBehavior = () => {
    if (lessThanTabletMedium) {
      if (window.scrollY > 56 * 1.5) {
        header.classList.add('fixed');
      } else {
        header.classList.remove('fixed');
      }
    } else {
      if (window.scrollY > 114 * 1.5) {
        header.classList.add('fixed');
      } else {
        header.classList.remove('fixed');
      }
    }
  };

  setHeaderBehavior();
  window.addEventListener('scroll', setHeaderBehavior);

  menuTitles.forEach((title) => {
    ['mouseenter', 'keyup'].forEach((e) => {
      title.addEventListener(e, () => {
        const { menuTitle } = title.dataset;

        menuTitles.forEach((title) => title.classList.remove('active'));
        title.classList.add('active');

        desktopMenu.classList.add('active');

        menuContents.forEach((content) => {
          const menuContent = content.dataset.menuContent;
          content.classList.remove('active');

          if (menuContent === menuTitle) {
            content.classList.add('active');

            submenuTitles.forEach((title) => title.classList.remove('active'));
            submenuContents.forEach((content) => content.classList.remove('active'));

            const submenuTitle = content.querySelector('[data-menu-subtitle]');
            const submenuContent = content.querySelector('[data-menu-subcontent]');

            if (!submenuTitle || !submenuContent) return;
            // submenuTitle.classList.add("active");
            submenuContent.classList.add('active');
          }
        });
      });
    });
  });

  submenuTitles.forEach((title) => {
    ['mouseenter', 'keyup'].forEach((e) => {
      title.addEventListener(e, () => {
        const submenuTitle = title.dataset.menuSubtitle;

        submenuTitles.forEach((title) => title.classList.remove('active'));
        title.classList.add('active');

        submenuContents.forEach((content) => {
          const submenuContent = content.dataset.menuSubcontent;
          content.classList.remove('active');

          if (submenuContent === submenuTitle) content.classList.add('active');
        });
      });
    });
  });

  if (greaterThanTabletMedium) {
    header.addEventListener('mouseleave', (e) => {
      if (!e.target.contains(header)) return;

      menuTitles.forEach((title) => title.classList.remove('active'));
      desktopMenu.classList.remove('active');
    });
  }

  const contentShadow = document.querySelector('[data-content-shadow]');
  const languagesTrigger = document.querySelectorAll('[data-choose-language]');
  const languagesMenu = document.querySelector('[data-languages-menu]');
  const languagesMenuCloseButton = document.querySelector('[data-languages-menu-close]');

  // const render = () => {
  //   if (state.uiState.isLanguageMenuOpened) {
  //     languagesMenu.classList.toggle('is_opened');
  //     contentShadow.classList.add('is_opened');
  //     disableScroll();
  //   } else {
  //     languagesMenu.classList.remove('is_opened');
  //     contentShadow.classList.remove('is_opened');
  //     enableScroll();
  //   }
  // };

  // languagesTrigger.forEach((trigger) => {
  //   trigger.addEventListener('click', () => {
  //     state.uiState.isLanguageMenuOpened = true;
  //     console.warn(state);
  //     render();
  //   });
  // });

  languagesTrigger.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      languagesMenu.classList.toggle('is_opened');
      contentShadow.classList.add('active');
      disableScroll();
    });
  });

  languagesMenuCloseButton.addEventListener('click', () => {
    contentShadow.classList.remove('active');
    languagesMenu.classList.remove('is_opened');
  });

  burger.addEventListener('click', () => {
    burger.classList.toggle('active');
    mobileMenu.classList.toggle('active');
    header.classList.toggle('clean');

    burger.classList.contains('active') ? disableScroll() : enableScroll();
  });

  const accordionItems = document.querySelectorAll('[data-accordion]');

  accordionItems.forEach((accordion) => {
    accordion.addEventListener('click', (e) => {
      if (e.target.matches('[data-accordion-title]')) accordion.classList.toggle('active');
    });
  });

  /*  */

  document.querySelector('body').classList.remove('preload');

  newsSubscription();
  initModal();
  initAOS();

  const feedbackButtons = document.querySelectorAll("[data-request='contact_manager']");
  const feedbackForm = document.querySelector('[data-feedback-form]');
  const feedbackFormSubmissionErrorMessage = feedbackForm.querySelector('[data-submission-error-message]');
  const feedbackFormSubmissionSuccessMessage = feedbackForm.querySelector('[data-submission-success-message]');

  feedbackButtons.forEach((button) => {
    button.addEventListener('click', () => {
      feedbackForm.classList.toggle('is_active');
      contentShadow.classList.add('active');
      disableScroll();
    });
  });

  // const anchors = document.querySelectorAll("a[href^='#']");

  // const handleAnchorClick = (e) => {
  //   e.preventDefault();

  //   const fullHref = e.target.href;
  //   const href = e.target.getAttribute('href');
  //   const destination = document.querySelector(href);
  //   scrollTo(destination);

  //   const url = new URL(fullHref);
  //   history.pushState({}, '', url);
  // };

  // anchors.forEach((anchor) => {
  //   anchor.addEventListener('click', (e) => handleAnchorClick(e));
  // });

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (contentShadow.classList.contains('active')) contentShadow.click();
      if (burger.classList.contains('active')) burger.click();
    }
  });

  let lastWidth = window.innerWidth;
  let resizeFinished;

  window.addEventListener('resize', (e) => {
    clearTimeout(resizeFinished);

    if (window.innerWidth !== lastWidth) {
      lastWidth = window.innerWidth;

      resizeFinished = setTimeout(() => {
        if (contentShadow.classList.contains('active')) contentShadow.click();
        if (burger.classList.contains('active')) burger.click();
        if (desktopMenu.classList.contains('active')) desktopMenu.classList.remove('active');
      }, 200);
    }
  });

  window.onYouTubeIframeAPIReady = (e) => {
    // console.warn('YouTube is ready!', e);
    const youtubeVideos = document.querySelectorAll('[data-youtube-video]');
    youtubeVideos.forEach((video) => playYoutubeVideo(video));
  };

  const videos = document.querySelectorAll('[data-video]');
  videos.forEach((video) => playVideo(video));

  /*  */

  const telInput = document.querySelector('[data-input-phone]');
  const iti = initIntlTelInput(telInput);

  telInput.addEventListener('input', (e) => {
    const isValidNumber = iti.isValidNumber();

    if (!isValidNumber) {
      e.target.setCustomValidity('Wrong number');
      return;
    }

    e.target.setCustomValidity('');
  });

  /*  */

  const form = feedbackForm.querySelector('form');
  if (form) form.addEventListener('submit', async (e) => sendContactForm(e));

  contentShadow.addEventListener('click', () => {
    if (greaterThanTabletMedium || feedbackForm.classList.contains('is_active')) enableScroll();

    contentShadow.classList.remove('active');
    languagesMenu.classList.remove('is_opened');
    feedbackForm.classList.remove('is_active');
    feedbackFormSubmissionErrorMessage.classList.remove('is_active');
    feedbackFormSubmissionSuccessMessage.classList.remove('is_active');
    form.reset();
  });
};

export default app;
